import MonitorRoutes from './MonitorRoutes'

export default MonitorRoutes
